function PoliticaPrivacidad() {
  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-900 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white dark:bg-slate-800 rounded-2xl shadow-xl border border-slate-200 dark:border-slate-700 overflow-hidden">
          <div className="bg-gradient-to-r from-blue-600 to-purple-600 px-8 py-12 text-center">
            <h1 className="text-3xl lg:text-4xl font-bold text-white">Política de Privacidad</h1>
            <div className="w-24 h-1 bg-white/30 mx-auto mt-4 rounded-full"></div>
          </div>
          <div className="p-8 lg:p-12 space-y-8">
            <section className="border-b border-slate-200 dark:border-slate-700 pb-6">
              <h2 className="text-xl font-bold text-slate-900 dark:text-slate-100 mb-4">1. Información que Recopilamos</h2>
              <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-4">En NeuroCrow, recopilamos la siguiente información:</p>
              <ul className="space-y-2 text-slate-600 dark:text-slate-300">
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Información de contacto empresarial (nombre, correo electrónico, teléfono)</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Datos de la página de Facebook y WhatsApp Business del negocio</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Conversaciones del chatbot con clientes</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Datos de uso y análisis del servicio</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Preferencias de configuración del chatbot</span>
                </li>
              </ul>
            </section>

            <section className="border-b border-slate-200 dark:border-slate-700 pb-6">
              <h2 className="text-xl font-bold text-slate-900 dark:text-slate-100 mb-4">2. Uso de la Información</h2>
              <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-4">Utilizamos la información recopilada para:</p>
              <ul className="space-y-2 text-slate-600 dark:text-slate-300">
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Proporcionar y mantener nuestro servicio de chatbots</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Mejorar la atención al cliente</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Personalizar respuestas y automatizaciones</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Generar análisis y reportes de rendimiento</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Optimizar la experiencia del usuario</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Cumplir con requisitos legales y regulatorios</span>
                </li>
              </ul>
            </section>

            <section className="border-b border-slate-200 dark:border-slate-700 pb-6">
              <h2 className="text-xl font-bold text-slate-900 dark:text-slate-100 mb-4">3. Protección de Datos</h2>
              <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-4">Implementamos medidas de seguridad robustas:</p>
              <ul className="space-y-2 text-slate-600 dark:text-slate-300">
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Encriptación de datos en tránsito y en reposo</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Evaluaciones regulares de seguridad</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Acceso limitado a información personal</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Almacenamiento seguro en servidores certificados</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Copias de seguridad periódicas</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Monitoreo continuo de seguridad</span>
                </li>
              </ul>
            </section>

            <section className="border-b border-slate-200 dark:border-slate-700 pb-6">
              <h2 className="text-xl font-bold text-slate-900 dark:text-slate-100 mb-4">4. Compartir Información</h2>
              <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-4">Podemos compartir información con:</p>
              <ul className="space-y-2 text-slate-600 dark:text-slate-300">
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Meta Platforms (Facebook, WhatsApp, Instagram) para la operación del servicio</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Proveedores de servicios esenciales (hosting, análisis)</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Socios comerciales con su consentimiento expreso</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Autoridades cuando sea requerido por ley</span>
                </li>
              </ul>
            </section>

            <section className="border-b border-slate-200 dark:border-slate-700 pb-6">
              <h2 className="text-xl font-bold text-slate-900 dark:text-slate-100 mb-4">5. Sus Derechos</h2>
              <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-4">Como cliente, tiene derecho a:</p>
              <ul className="space-y-2 text-slate-600 dark:text-slate-300">
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Acceder a su información personal</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Corregir datos inexactos</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Solicitar la eliminación de sus datos</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Oponerse al procesamiento de sus datos</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Recibir una copia de sus datos</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Revocar su consentimiento</span>
                </li>
              </ul>
            </section>

            <section className="border-b border-slate-200 dark:border-slate-700 pb-6">
              <h2 className="text-xl font-bold text-slate-900 dark:text-slate-100 mb-4">6. Contacto para Privacidad</h2>
              <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-4">Para consultas sobre privacidad:</p>
              <ul className="space-y-2 text-slate-600 dark:text-slate-300">
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Correo: privacy@neurocrow.com</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Dirección: Del Volcan, Tijuana, B.C., México</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Teléfono: +1 (619) 761-2314</span>
                </li>
              </ul>
            </section>

            <section>
              <p className="text-center text-sm text-slate-500 dark:text-slate-400 bg-slate-100 dark:bg-slate-700 rounded-lg py-3 px-4">Última actualización: 18 de Noviembre de 2024</p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PoliticaPrivacidad; 